import { MemberPersonalInformation } from '../../dto/member-personal-information';
import { MemberRecord } from '../../dto/member-record';
import { MemberUser } from '../../dto/member-user';
import { SubmissionRequest } from './submission-request';

export class ChangePersonalDetailsRequest extends SubmissionRequest {
  public socialInsuranceNumber: string = '';
  public birthdate: string = '';
  public genderId: number = 0;
  public pronounId: number | null = null;

  // Not From API
  public files: File[] = [];

  constructor(user?: MemberUser | MemberRecord, sin?: string) {
    super();
    const personalDetails = this.getPersonalDetails(user);

    if (!!user) {
      this.memberId = user.id;
      this.birthdate = personalDetails?.formattedBirthDate?.replace(new RegExp(' ', 'g'), '') ?? '';
      this.genderId = personalDetails?.genderId ?? 0;
      this.pronounId = personalDetails?.pronounId ?? null;
    }

    if (!!sin) {
      this.socialInsuranceNumber = sin;
    }
  }

  private getPersonalDetails(user?: MemberUser | MemberRecord): MemberUser | MemberPersonalInformation | undefined {
    if (!user) {
      return undefined;
    }

    if ('personalDetails' in user) {
      return user.personalDetails;
    }

    return user;
  }
}
